import {
  Box,
  Button as MuiButton,
  Card,
  CardContent,
  CircularProgress as MuiCircularProgress,
  Divider as MuiDivider,
  FormControl,
  Grid,
  InputLabel,
  Checkbox,
  FormGroup,
  FormControlLabel,
  LinearProgress as MuiLinearProgress,
  MenuItem,
  Select as MuiSelect,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import { spacing } from "@mui/system";
import PropTypes from "prop-types";
import React, { useCallback, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import styled from "styled-components";
import { setSnackbar } from "../../snackbar/api/snackbar";
import { post, put } from "../api/actions";
import { getById as getPropertyManager } from "modules/propertyManager/api/actions";

const LinearProgress = MuiLinearProgress;
const Divider = styled(MuiDivider)(spacing);
const Button = styled(MuiButton)(spacing);
const CircularProgress = styled(MuiCircularProgress)(spacing);
const TextField = styled(MuiTextField)(spacing);
const Select = styled(MuiSelect)(spacing);

const UnitForm = (props) => {
  // Handles vendor drop down
  const dispatch = useDispatch();

  const onFieldChange = (event) => {
    props.units.data.unit[event.target.name] = event.target.value;
  };

  const toggleActive = () => {
    setLeaseLight(!leaseLight);
    props.units.data.unit.leaseLight = !leaseLight;
  };

  const toggleActiveCommon = () => {
    setCommonAccount(!commonAccount);
    props.units.data.unit.commonAccount = !commonAccount;
  };


  // Handles vendor drop down
  const [state, setState] = React.useState("");
  const [leaseLight, setLeaseLight] = React.useState(props.units.data.unit.leaseLight == 1 ? true : false);
  const [commonAccount, setCommonAccount] = React.useState(props.units.data.unit.commonAccount == 1 ? true : false);
  const [unitTypes, setUnitTypes] = React.useState(props.unitTypes.data.unitTypesList.items);

  const save = async () => {
    const u = props.units.data.unit;
    const newUnit = {
      id: u.id,
      uuid: u.uuid,
      unitTypeId: u.unitTypeId,
      propertyId: props.properties.data.property.id,
      propertyManagerId: u.propertyManagerId,
      developerId: u.developerId,
      ownerId: u.ownerId,
      address1: u.address1,
      address2: u.address2,
      buildingNumber: u.buildingNumber,
      bedrooms: u.bedrooms,
      baths: u.baths,
      city: u.city,
      state: u.state,
      leaseLight: u.leaseLight,
      commonAccount: u.commonAccount,
      zip: u.zip,
      heatingType: u.heatingType,
      sqFt: u.sqFt,
    };

    if (!newUnit.id) {
      props.post(newUnit);
    } else {
      await props.put(newUnit);
      await props.getPropertyManager(newUnit.propertyManagerId);

    }
    dispatch(setSnackbar(true, "success", "Unit updated"));
    props.onUpdate();
  };

  

  if (props.propertyManagers.isLoading || props.units.unitIsLoading) {
    return (
      <Card mb={6}>
        <CardContent>
          <Typography variant="h3" gutterBottom>
            Loading...
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent>
        {/* Unit Details */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {/* Address Row */}
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
              <TextField
                label="Address 1"
                type="text"
                onChange={onFieldChange}
                name="address1"
                defaultValue={props.units.data.unit.address1}
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
              <TextField
                label="Address 2"
                type="text"
                onChange={onFieldChange}
                defaultValue={props.units.data.unit.address2}
                name="address2"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>

          {/* Dropdowns Row */}
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 8px)' } }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="selectedAccountStatusDropDownLabel">
                  Owners
                </InputLabel>
                <Select
                  labelId="selectedAccountStatusDropDownLabel"
                  id="selectedAccountStatusDropDown"
                  defaultValue={props.units.data.unit.ownerId}
                  onChange={onFieldChange}
                  name="ownerId"
                >
                  {props.owners.data.ownersList.items.map((item, index) => (
                    <MenuItem id="AccountStatusOption1" value={item.id}>
                      {`${item.name} - ${item.glCode}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(50% - 8px)' } }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="selectedUnitTypeDropDownLabel">
                  Unit Type
                </InputLabel>
                <Select
                  labelId="selectedUnitTypeDropDownLabel"
                  id="selectedUnitTypeDropDown"
                  defaultValue={props.units.data.unit.unitTypeId}
                  onChange={onFieldChange}
                  name="unitTypeId"
                >
                  {props.apl.genericTypes.unitType.data.map((item, index) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
          {/* City, State, Zip Row */}
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(60% - 8px)' } }}>
              <TextField
                label="City"
                type="text"
                onChange={onFieldChange}
                defaultValue={props.units.data.unit.city}
                name="city"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box sx={{ flex: { xs: '1 1 calc(50% - 4px)', sm: '1 1 calc(20% - 8px)' } }}>
              <TextField
                label="State"
                type="text"
                onChange={onFieldChange}
                defaultValue={props.units.data.unit.state}
                name="state"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box sx={{ flex: { xs: '1 1 calc(50% - 4px)', sm: '1 1 calc(20% - 8px)' } }}>
              <TextField
                label="Zip"
                type="text"
                onChange={onFieldChange}
                defaultValue={props.units.data.unit.zip}
                name="zip"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>

          {/* SQ FT, Building Number, Bedrooms, Baths Row */}
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Box sx={{ flex: { xs: '1 1 calc(50% - 4px)', sm: '1 1 calc(25% - 6px)' } }}>
              <TextField
                label="SQ FT"
                type="text"
                onChange={onFieldChange}
                defaultValue={props.units.data.unit.sqFt}
                name="sqFt"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box sx={{ flex: { xs: '1 1 calc(50% - 4px)', sm: '1 1 calc(25% - 6px)' } }}>
              <TextField
                label="Building Number"
                type="text"
                onChange={onFieldChange}
                defaultValue={props.units.data.unit.buildingNumber}
                name="buildingNumber"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box sx={{ flex: { xs: '1 1 calc(50% - 4px)', sm: '1 1 calc(25% - 6px)' } }}>
              <TextField
                label="Bedrooms"
                type="text"
                onChange={onFieldChange}
                defaultValue={props.units.data.unit.bedrooms}
                name="bedrooms"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box sx={{ flex: { xs: '1 1 calc(50% - 4px)', sm: '1 1 calc(25% - 6px)' } }}>
              <TextField
                label="Baths"
                type="text"
                onChange={onFieldChange}
                defaultValue={props.units.data.unit.baths}
                name="baths"
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
          {/* Checkboxes Row */}
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start' }}>
            <Box sx={{ flex: { xs: '1 1 100%', md: '1 1 calc(33% - 8px)' } }}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.units.data.unit.commonAccount == 1 ? true : false}
                      onChange={toggleActiveCommon}
                      name="commonAccount"
                    />
                  }
                  label="Common Account"
                />
              </FormGroup>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.units.data.unit.leaseLight == 1 ? true : false}
                      onChange={toggleActive}
                      name="leaseLight"
                    />
                  }
                  label="Lease Light"
                />
              </FormGroup>
            </Box>
          </Box>

          {/* Save Button */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <MuiButton variant="contained" onClick={save} color="secondary">
              Save
            </MuiButton>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

// Component Properties
UnitForm.propTypes = {
  units: PropTypes.object.isRequired,
  propertyManagers: PropTypes.object.isRequired,
  owners: PropTypes.object.isRequired,
  unitTypes: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  put: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  properties: PropTypes.object.isRequired,
  getPropertyManager: PropTypes.func.isRequired,
};

function UnitFormState(state) {
  return {
    units: state.units,
    propertyManagers: state.propertyManagers,
    apl: state.apl,
    owners: state.owners,
    unitTypes: state.unitTypes,
    properties: state.properties,
  };
}
export default connect(UnitFormState, { put, post, getPropertyManager })(UnitForm);
